import api from 'infra/config/api';

export default function bookService(bookId) {
    const url = `/book.php?book_id=${bookId}`
    return api
    .url(url)
    .get()
    .json();
}